<template>
  <header v-if="compact" class="legacy-mobile-identity">
    <div><strong>{{ _g_SelectedTicker.ticker || 'Selecciona un valor' }}</strong><span>{{ _g_SelectedTicker.entry_type_name }}</span></div>
    <p>{{ _g_SelectedTicker.nom }}</p>
    <small>{{ [_g_SelectedTicker.index_valor, _g_SelectedTicker.country, _g_SelectedTicker.divisa].filter(Boolean).join(' · ') }}</small>
  </header>
  <nav v-else-if="_g_IsUserLogged" class="legacy-mobile-tickers" aria-label="Valores encontrados">
    <span class="legacy-mobile-tickers__count">{{ _g_Stocks.length }}<small>valores</small></span>
    <div ref="strip" class="legacy-mobile-tickers__strip">
      <button v-for="ticker in _g_Stocks" :key="ticker.ticker" type="button"
        :aria-pressed="String(ticker.ticker === (_g_SelectedTicker || {}).ticker)"
        @click="selectTicker(ticker)">
        {{ ticker.ticker }}
      </button>
    </div>
  </nav>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  props: { compact: Boolean },
  computed: { ...mapGetters(['_g_Stocks', '_g_SelectedTicker', '_g_IsUserLogged']) },
  watch: { _g_SelectedTicker() { this.$nextTick(this.revealSelected); } },
  mounted() { this.revealSelected(); },
  methods: {
    ...mapMutations(['setSelectedTicker']),
    selectTicker(ticker) {
      this.setSelectedTicker(ticker);
    },
    revealSelected() {
      const strip = this.$refs.strip;
      const button = strip && strip.querySelector('[aria-pressed="true"]');
      if (!button) return;
      if (button.offsetLeft < strip.scrollLeft) strip.scrollLeft = button.offsetLeft;
      else if (button.offsetLeft + button.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = button.offsetLeft + button.offsetWidth - strip.clientWidth;
    }
  }
};
</script>
<style scoped>
.legacy-mobile-tickers { display: flex; min-width: 0; border-block: 1px solid #8884; }
.legacy-mobile-tickers__count { min-width: 58px; padding: 4px 8px; text-align: center; background: var(--color-primary-primary, #11111e); color: white; font-size: 19px; }
small { display: block; font-size: 11px; }
.legacy-mobile-tickers__strip { display: flex; position: relative; min-width: 0; overflow-x: auto; }
button { flex: 0 0 auto; min-height: 48px; padding: 8px 14px; border: 0; border-right: 1px solid #8884; background: var(--color-surface, white); color: inherit; font: inherit; font-size: 14px; cursor: pointer; }
button[aria-pressed="true"] { color: #007e9e; box-shadow: inset 0 -3px #00add9; font-weight: bold; }
</style>
